import React, { useEffect } from 'react';
import { HiOutlineCheckCircle, HiOutlineXCircle, HiOutlineExclamation, HiOutlineInformationCircle, HiOutlineX } from 'react-icons/hi';

const ICONS = {
  success: <HiOutlineCheckCircle />,
  error: <HiOutlineXCircle />,
  warning: <HiOutlineExclamation />,
  info: <HiOutlineInformationCircle />,
};

export default function Toast({ toasts, removeToast }) {
  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} onRemove={() => removeToast(t.id)} />
      ))}
    </div>
  );
}

function ToastItem({ toast, onRemove }) {
  useEffect(() => {
    const timer = setTimeout(onRemove, toast.duration || 4000);
    return () => clearTimeout(timer);
  }, [onRemove, toast.duration]);

  return (
    <div className={`toast-item toast-${toast.type || 'info'}`}>
      <span className="toast-icon">{ICONS[toast.type || 'info']}</span>
      <div className="toast-content">
        {toast.title && <div className="toast-title">{toast.title}</div>}
        <div className="toast-message">{toast.message}</div>
      </div>
      <button className="toast-close" onClick={onRemove}><HiOutlineX /></button>
    </div>
  );
}
